import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'en_XD',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: false,
  },
  '845fe32c-31c6-42c5-a92e-81fcd0633acc',
  ''
);
